/** クーポン種類 */
export enum CouponType {
  VISA_SPECIAL_PRICE = 1,
  PREMIUM_CASE = 2,
  VISA_CASE = 3,
  VISA_BIRTHDAY = 4,
  VISA_DISCOUNT = 5,
  BIRTHDAY = 6,
  VISA_SHIPPING = 7,
  FIRST_SHIPPING_FREE = 8,
  VIP_PLATINUM_CASE = 9,
  VIP_PLATINUM_SHIPPING = 10,
  VIP_BLACK_CASE = 11,
  VIP_BLACK_SHIPPING = 12,
}

export enum CouponRank {
  REGULAR = 'regular',
  PREMIUM = 'premium',
  VISA = 'visa',
  PLATINUM = 'platinum',
  BLACK = 'black',
}

/** 特典適用条件 */
export enum CouponConditionType {
  VARIANT_CODE = 'variant_code',
  TOTAL_AMOUNT = 'total_amount',
}
